import PricingContainer from "../../../components/pages/other/pricing";

const Pricing = () => {
  return <PricingContainer />;
};

export default Pricing;
